import { isNative } from './native.ts'

/** The club's PUBLIC address: where the app server lives (its admin endpoints and exports), what a printed label's QR points to (`<origin>/a/<TAG>`,
 *  M2) and where a one-time access link sends a person. In a browser it is the page's own origin, unless the build says otherwise
 *  (`VITE_PUBLIC_ORIGIN`). In the native app (M19b) the page's origin is the shell's own (`capacitor://localhost`, `https://localhost`), which is no
 *  address anybody else can reach: the native build MUST say it (`npm run mobile:sync` sets it), and without it there is none (null), never the
 *  shell's. A configured value is reduced to its origin (scheme, host, port: no path, no trailing slash) and must be http or https. */
export function resolvePublicOrigin(configured: string | undefined, pageOrigin: string | undefined, native: boolean): string | null {
  const c = configured?.trim()
  if (c) {
    try {
      const u = new URL(c)
      return u.protocol === 'http:' || u.protocol === 'https:' ? u.origin : null
    } catch { return null }
  }
  if (native) return null
  return pageOrigin && /^https?:\/\//.test(pageOrigin) ? pageOrigin : null
}

export const publicOrigin = (): string | null =>
  resolvePublicOrigin(import.meta.env.VITE_PUBLIC_ORIGIN as string | undefined, globalThis.location?.origin, isNative())

/** An absolute URL on the app server, for a path that starts with '/'. Null when this build knows no public origin (a native build made without one). */
export function serverUrl(path: string, origin: string | null = publicOrigin()): string | null {
  return origin ? `${origin}${path.startsWith('/') ? path : `/${path}`}` : null
}
